// removed by extract-text-webpack-plugin
module.exports = {"hidden":"header-module__hidden___2WNNn","show":"header-module__show___19OM7","header-table":"header-module__header-table___3JuLa","header-logo":"header-module__header-logo___2hrDl","signup-top":"header-module__signup-top___1R-fm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/header.module.scss
// module id = 285
// module chunks = 1